var React = require('react');

function ArrowLeftGreen (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.292999 9.70694L8 17.4139L9.414 15.9999L3.414 9.99994L21 9.99994C21.553 9.99994 22 9.55194 22 8.99994C22 8.44794 21.553 7.99994 21 7.99994L3.414 7.99994L9.414 1.99994L8 0.585941L0.292999 8.29294C-0.0980015 8.68394 -0.0980015 9.31594 0.292999 9.70694Z"}));
}

ArrowLeftGreen.defaultProps = {"width":"22","height":"18","viewBox":"0 0 22 18"};

module.exports = ArrowLeftGreen;

ArrowLeftGreen.default = ArrowLeftGreen;
